import React, { FC } from 'react';
import { FieldProps } from 'formik';
import { FormControlLabel, Switch, FormControlLabelProps } from '@mui/material';
import { LabelText } from '@styles/StyledTypography';

interface IProps extends FieldProps {
  id?: string;
  label: string;
  wrap?: boolean;
  labelPlacement: FormControlLabelProps['labelPlacement'];
  onChange?: (checked: boolean) => void;
}
export const SwitchField: FC<IProps> = ({
  wrap,
  label,
  id,
  form: _form,
  field: { name, value, ...field },
  labelPlacement = 'start',
  ...props
}) => (
  <FormControlLabel
    label={<LabelText wrap={wrap}>{label}</LabelText>}
    labelPlacement={labelPlacement}
    control={
      <Switch
        {...props}
        {...field}
        id={id || name}
        name={name}
        checked={!!value}
        onChange={(event, checked): void => {
          field.onChange(event);
          props.onChange?.(checked);
        }}
      />
    }
  />
);
